import { Subject } from "rxjs";

import MutationObserverInjector from "./MutationObserverInjector";
import { MOIDefinition } from "./types";

interface IntersectionObserverInjectorConfig {
    rootMargin?: string;
    threshold?: number | number[];
}

class IntersectionObserverInjector {
    private readonly io: IntersectionObserver;
    private readonly foundElements = new WeakSet();
    private readonly moiDefinition: MOIDefinition;

    public readonly targets$ = new Subject<HTMLElement>();

    constructor(
        IntersectionObserverCls: typeof IntersectionObserver,
        private readonly moi: MutationObserverInjector,
        moiSelector: string,
        config?: IntersectionObserverInjectorConfig
    ) {
        this.io = new IntersectionObserverCls(this.intersectionCalback, {
            rootMargin: config?.rootMargin,
            threshold: config?.threshold,
        });
        this.moiDefinition = {
            targetSelector: moiSelector,
        };
    }

    public start(): void {
        const moiTargets$ = this.moi.register(this.moiDefinition);

        moiTargets$.subscribe((element) => {
            this.io.observe(element);
        });
    }

    public stop(): void {
        this.moi.unregister(this.moiDefinition);
        this.io.disconnect();
    }

    private intersectionCalback = (
        entries: IntersectionObserverEntry[]
    ): void => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const { target } = entry;
                if (
                    !this.foundElements.has(target) &&
                    target instanceof HTMLElement
                ) {
                    this.foundElements.add(target);
                    this.targets$.next(target);
                }
            }
        });
    };
}

export default IntersectionObserverInjector;
